import { ThreeRow } from "../../core/layouts";
import CustomInput from "../CustomInput/CustomInput";
import variables from "../../themes/base/styles/variables";
import PasswordCriteria from "../PasswordCriteria";

const SetPasswordStyle = {
  style: { position: "relative" },
  middleBottomSectionStyle: {
    justifyContent: "flex-end",
  },
  bottomSectionStyle: {
    marginTop: variables.marginLarge,
  },
  forgotPassword: {
    marginTop: variables.marginMediumLarge,
  },
  middleSectionStyle: {
    marginTop: variables.marginLarge,
  },
};

export default function SetPassword({
  handleChange,
  handleBlur,
  fieldNames,
  errors,
  values,
  labels,
  placeholders,
  touched,
  size,
}) {
  const password = values[fieldNames.PASSWORD];
  return (
    <ThreeRow
      style={SetPasswordStyle.style}
      topSection={
        <CustomInput
          placeholder={placeholders[fieldNames.PASSWORD]}
          value={password}
          onChange={handleChange}
          onBlur={handleBlur}
          label={labels[fieldNames.PASSWORD]}
          name={fieldNames.PASSWORD}
          isPassword
          required
          size={size}
          error={touched[fieldNames.PASSWORD] && errors[fieldNames.PASSWORD]}
          autoComplete="current-password"
        />
      }
      middleSection={
        <CustomInput
          placeholder={placeholders[fieldNames.CONFIRM_PASSWORD]}
          value={values[fieldNames.CONFIRM_PASSWORD]}
          onChange={handleChange}
          onBlur={handleBlur}
          label={labels[fieldNames.CONFIRM_PASSWORD]}
          name={fieldNames.CONFIRM_PASSWORD}
          isPassword
          required
          size={size}
          error={
            touched[fieldNames.CONFIRM_PASSWORD] &&
            errors[fieldNames.CONFIRM_PASSWORD]
          }
        />
      }
      bottomSection={<PasswordCriteria password={password} />}
      bottomSectionStyle={SetPasswordStyle.bottomSectionStyle}
      middleSectionStyle={SetPasswordStyle.middleSectionStyle}
    />
  );
}
